import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getById = createAsyncThunk("jabatanAkademik/getById",
async(val) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/data/upload/prodi/${val}`
        const response = await jwtAuthAxios.get(url)
        return response.data;
    } catch(response){
        throw response
    }
});

export const getByProdiId = createAsyncThunk("jabatanAkademik/getByProdiId",
async(val) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/data/upload/prodi/prodi/${val}`
        const response = await jwtAuthAxios.get(url)
        return response.data;
    } catch(response){
        throw response
    }
});

export const getByIdDosen = createAsyncThunk("jabatanAkademik/getByIdDosen",
async(val) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/data/upload/dosen/dosen/${val}`
        const response = await jwtAuthAxios.get(url)
        return response.data;
    } catch(response){
        throw response
    }
});

export const findAll = createAsyncThunk("jabatanAkademik/findAll",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/data/upload/prodi`
            const response = await jwtAuthAxios.get(url)
            return response.data;
        } catch(response){
            throw response
        }
    });

export const save = createAsyncThunk("jabatanAkademik/save",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/data/upload/prodi`
            const response = await jwtAuthAxios.post(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });


export const saveDosen = createAsyncThunk("jabatanAkademik/saveDosen",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/data/upload/dosen`
            const response = await jwtAuthAxios.post(url,val)
            return response.data;
        } catch(response){
            throw response
        }
    });


export const update = createAsyncThunk("jabatanAkademik/update",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/data/upload/prodi`
            const response = await jwtAuthAxios.put(url,val);
            return response.data;
        } catch(response){
            throw response
        }
    });

export const remove = createAsyncThunk("jabatanAkademik/remove",
    async(val) => {
        try{
            let token = await localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `v1/data/upload/prodi/${val}`
            const response = await jwtAuthAxios.delete(url);
            return response.data;
        } catch(response){
            throw response
        }
    });


const initialState = {
    loading: false,
    data: {},
    dataDosen : {},
    dataList: [],
}

const jabatanAkademikSlice = createSlice({
    name:"jabatanAkademik",
    initialState: initialState,
    extraReducers: (builder) => {
    builder
        .addCase(saveDosen.pending, (state) => {
            state.loading = true;
        })
        .addCase(saveDosen.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(saveDosen.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(getById.pending, (state) => {
            state.loading = true;
        })
        .addCase(getById.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(getById.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(findAll.pending, (state) => {
            state.loading = true;
        })
        .addCase(findAll.fulfilled, (state, action) => {
            state.dataList = action.payload;
            state.loading = false;
        })
        .addCase(findAll.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(save.pending, (state) => {
            state.loading = true;
        })
        .addCase(save.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(save.rejected, (state, action) => {
            state.loading = false;
        })
    builder
        .addCase(update.pending, (state) => {
            state.loading = true;
        })
        .addCase(update.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(update.rejected, (state, action) => {
            state.loading = false;
        })

    builder
        .addCase(remove.pending, (state) => {
            state.loading = true;
        })
        .addCase(remove.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(remove.rejected, (state, action) => {
            state.loading = false;
        })

    builder
        .addCase(getByProdiId.pending, (state) => {
            state.loading = true;
        })
        .addCase(getByProdiId.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        })
        .addCase(getByProdiId.rejected, (state, action) => {
            state.loading = false;
        })

    builder
        .addCase(getByIdDosen.pending, (state) => {
            state.loading = true;
        })
        .addCase(getByIdDosen.fulfilled, (state, action) => {
            state.dataDosen = action.payload;
            state.loading = false;
        })
        .addCase(getByIdDosen.rejected, (state, action) => {
            state.loading = false;
        })
    }
})
export const jabatanAkademikSelector = (state) => state.jabatanAkademik;
export default jabatanAkademikSlice.reducer;